// Some starter smooth scrolling JS
// Uses jQuery animate() method - https://api.jquery.com/animate/
(function($) {
	// Add smooth scrolling to all links
	$("a").not('.open-popup-link, .modal-link, .gform_button').on('click', function(event) {
		//Exclude anchors inside p.open-popup-link
		let parent = $(this).parent();
		if (parent.hasClass('open-popup-link')) {
			return;
		}

		//Exclude anchors for lightbox thing

		// Make sure this.hash has a value before overriding default behavior
		if (this.hash !== '' && this.hash != '#search') {
			// Store hash
			var hash = this.hash;

			//only intercept if the hash is on the page
			if (!$(hash).length) return;

			//If the hash is a dialog, no thank you
			if ($(hash)[0].tagName == 'DIALOG') {
				return;
			}

			// Prevent default anchor click behavior
			event.preventDefault();
			// headerHeight = $("header.site-header").height() + 100; // Get fixed header height

			// Using jQuery's animate() method to add smooth page scroll
			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			$('html, body').animate({
				scrollTop: $(hash).offset().top - 120
			}, 800, function() {

				// Add hash (#) to URL when done scrolling (default click behavior)
				//window.location.hash = hash;
				history.pushState(null, window.title, window.location.href.split('#')[0]+hash);

			});

			//Close the mega menu
			$('.has-mega-menu-open').removeClass('has-mega-menu-open');
		} // End if
	});

	if(window.location.hash && $(window.location.hash).length) {
		// smooth scroll to the anchor id
		// event.preventDefault();
		// headerHeight = $("header.site-header").height() + 100; // Get fixed header height

		$('html, body').animate({
			scrollTop: $(window.location.hash).offset().top - 120
		}, 800);
	}

	// close mega menu if page scrolls
	if('#menu-main.has-menu-open .has-mega-menu-open') {
		$(document).on('scroll', function() {
			$('#menu-main.mega-menu-open .has-mega-menu').removeClass('has-mega-menu-open');
			$('#menu-hrf-menu.mega-menu-open .has-mega-menu').removeClass('has-mega-menu-open');
		})
	}
	
})(jQuery);
